<template>
  <mdb-container fluid>
    <material-card
      title="Medikamentenblatt"
      card-icon="table"
    >
      <template v-slot:actions>
        <mdb-btn
          color="#333"
          class="py-2 px-3 z-depth-0 border border-light rounded"
          @click="openModal"
        >
          <mdb-icon
            color="black"
            icon="plus"
          />
        </mdb-btn>
        <mdb-btn
          color="#333"
          class="py-2 px-3 z-depth-0 border border-light rounded"
          @click="modalSetting=!modalSetting"
        >
          <mdb-icon
            color="black"
            icon="cog"
          />
        </mdb-btn>
      </template>
      <template v-slot:content>
        <div class="d-flex justify-content-center">
          <mdb-spinner big v-if="loading"/>
        </div>
        <mdb-accordion
          table
          v-if="tableData.length > 0"
        >
          <mdb-accordion-pane
            class="d-flex mb-2"
            title=""
            type="table"
            v-for="(tbl, index) in tableData"
            :key="index"
            :isOpen="openPaneNum==index"
            @pane-clicked="handlePaneOpened(index)"
          >
            <mdb-chip
              color="blue lighten-1 mb-0 text-white"
              slot="title"
              class="px-2 mr-1 float-left"
            >
              {{ tbl.MedikamentText }}
            </mdb-chip>
            <div class="px-5 pt-4 pb-1">
              <mdb-tbl
                 responsive bordered
              >
                <mdb-tbl-head>
                  <tr class="mdb-color grey lighten-3">
                    <th>
                      <strong><i class="fas fa-eye-dropper mr-2" aria-hidden="true"></i>Art</strong>
                    </th>
                    <th>
                      <strong><mdb-icon icon="circle" :style="'color:'+tbl.ArtFarbe" /> {{ tbl.ArtText }}</strong>
                    </th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                  <tr
                    v-for="(t, i) in titleMedicine"
                    :key="i"
                  >
                    <td>
                      <strong>
                        <mdb-icon :icon="t.icon" />  {{ t.title }}
                      </strong>
                    </td>
                    <td v-if="tbl[t.id] && t.type == 'String'">
                      {{ tbl[t.id] }}
                    </td>
                    <td v-else-if="tbl[t.id] && t.type == 'Date'">
                      {{ tbl[t.id] | dateFormat }}
                    </td>
                    <td v-else> - </td>
                  </tr>
                </mdb-tbl-body>
              </mdb-tbl>

              <mdb-btn
                size="md"
                color="red darken-2"
                class="mt-1 mb-4"
                @click="openDeleteModal(tbl.Id)"
              >
                 <mdb-icon icon="file-excel" class="mr-1" /> Absetzen
              </mdb-btn>
            </div>
          </mdb-accordion-pane>
        </mdb-accordion>
        <list-group-item
          v-else
          :title="'Keine Einträge gefunden'"
        />

        <mdb-row>
          <mdb-col sm="12">
            <mdb-btn
              color="primary"
              class="float-left ml-0 mt-3 mb-2"
              @click="modalCourse=!modalCourse"
            >
              Verlauf <mdb-icon icon="plus" />
            </mdb-btn>
          </mdb-col>

          <mdb-col sm="12">
            <mdb-tbl
              responsive
              bordered
              fixed
              maxHeight="400px"
              v-if="verlaufData.rows.length > 0"
            >
              <mdb-tbl-head>
                <tr class="mdb-color grey lighten-3">
                  <th
                    v-for="(column, i) in verlaufData.columns"
                    :key="i"
                  >
                    <strong> {{ column.label }} </strong>
                  </th>
                </tr>
              </mdb-tbl-head>
              <mdb-tbl-body>
                <tr
                    v-for="(row, i) in verlaufData.rows"
                    :key="i"
                  >
                    <td> {{ row.Datum }} </td>
                    <td> {{ row.AenderungVon }} </td>
                    <td> {{ row.MedikamentText }} </td>
                    <td> {{ row.ArtText }} </td>
                    <td> {{ row.Kommentar }} </td>
                </tr>
              </mdb-tbl-body>
            </mdb-tbl>

            <list-group-item
              class="d-flex"
              v-else
              :title="'Keine Einträge gefunden'"
            />
          </mdb-col>
        </mdb-row>
      </template>
    </material-card>
    <add-medicine-sheet-modal
      :modal-state="modal"
      :art="tempArtOptions"
      @close="closeModal"
      @save="saveModal"
    />
    <add-medicine-course-modal
      :modal-state="modalCourse"
      :art="artOptions"
      :medikament="medikamentOption"
      @close="modalCourse=false"
      @save="saveCourseModal"
    />
    <delete-modal
      :modal-state="modalDelete"
      title="Medikament absetzen?"
      description="Wollen Sie das Medikament Bromazepam wirklich absetzen?"
      @close="close"
      @save="deleteMedicine"
    />
    <setting-modal
      :modal-state="modalSetting"
      @close="closeSettingModal"
      @filter="saveFilter"
    >
     <template v-slot:content>
        <mdb-input
          v-model="isTrue"
          class="my-2"
          type="checkbox"
          id="cancelled"
          name="zeitlich_abgesetzte_medikamente"
          label="zeitlich abgesetzte Medikamente"
        />
        <mdb-input
          v-model="isInterval"
          class="my-2"
          type="checkbox"
          id="interval"
          name="intervall_anzeigen"
          label="Intervall anzeigen"
        />
     </template>
    </setting-modal>
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbBtn,
  mdbIcon,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbAccordion,
  mdbAccordionPane,
  mdbChip,
  mdbInput,
  mdbSpinner,
  mdbRow,
  mdbCol
} from 'mdbvue';
const MaterialCard = () => import('@/components/card/MaterialCard')
const AddMedicineSheetModal = () => import('@/components/modals/AddMedicineSheetModal')
const AddMedicineCourseModal = () => import('@/components/modals/AddMedicineCourseModal')
const ListGroupItem = () => import('@/components/accordion/ListGroupItem')
const DeleteModal = () => import('@/components/modals/DeleteModal')
const SettingModal = () => import('@/components/modals/SettingModal')
import utils from '@/mixins/Utils'

export default {
  name: 'Medikamentenblatt',
  mixins: [utils()],
  components: {
    AddMedicineSheetModal,
    AddMedicineCourseModal,
    ListGroupItem,
    DeleteModal,
    SettingModal,
    MaterialCard,
    mdbContainer,
    mdbBtn,
    mdbIcon,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    mdbAccordion,
    mdbAccordionPane,
    mdbChip,
    mdbInput,
    mdbSpinner,
    mdbRow,
    mdbCol
  },

  data () {
    return {
      modal: false,
      modalCourse: false,
      modalSetting: false,
      modalDelete: false,
      openPaneNum: null,
      titleMedicine: [
        {
          title: 'FN',
          id: 'GabeFN',
          icon: 'cloud-meatball',
          type: 'String'
        },
        {
          title: 'F',
          id: 'GabeF',
          icon: 'coffee',
          type: 'String'
        },
        {
          title: 'M',
          id: 'GabeM',
          icon: 'sun',
          type: 'String'
        },
        {
          title: 'S',
          id: 'GabeS',
          icon: 'clock',
          type: 'String'
        },
        {
          title: 'N',
          id: 'GabeN',
          icon: 'moon',
          type: 'String'
        },
        {
          title: 'Ang. von',
          id: 'BeginArzt',
          icon: 'user-md',
          type: 'String'
        },
        {
          title: 'Änderung von',
          id: 'AenderungVon',
          icon: 'medkit',
          type: 'String'
        },
        {
          title: 'Ansetzen',
          id: 'AenderungAm',
          icon: 'calendar-day',
          type: 'Date'
        }
      ],
      tableData: [],
      verlaufData: {
        columns: [
          {
            label: 'Datum Uhrzeit',
            field: 'Datum',
            sort: 'asc'
          },
          {
            label: 'User',
            field: 'AenderungVon',
            sort: 'asc'
          },
          {
            label: 'Medicine',
            field: 'MedikamentText',
            sort: 'asc'
          },
          {
            label: 'Art',
            field: 'ArtText',
            sort: 'asc'
          },
          {
            label: 'Kommentar',
            field: 'Kommentar',
            sort: 'asc'
          },
        ],
        rows: []
      },
      loading: false,
      medikamentOption: [],
      artOptions: [],
      isTrue: false,
      isInterval: false,
      intervalData: [],
      tempArtOptions: [],
      deleteMedicineID: null
    }
  },

  created() {
    this.getArtOptions()
    this.loadMedicine()
  },

  methods: {
    handlePaneOpened (num) {
      if (this.openPaneNum == num) {
        return (this.openPaneNum = null)
      }
      this.openPaneNum = num;
    },

    openDeleteModal(id) {
      this.modalDelete = !this.modalDelete
      this.deleteMedicineID = id
    },

    close () {
      this.modalDelete = false
      this.deleteMedicineID = null
    },

    deleteMedicine () {
      let data = {
        AenderungVon: this.loginUser.username,
        Id: this.deleteMedicineID,
      }
      this.$http.put('/Medikamentenblatt', data)
        .then(res => {
          if(res.data) {
              this.$notify.success({message: 'Beenden Sie die Einnahme von Medikamenten erfolgreich', position: 'top right', closeButton: false, timeOut: 5000})
              this.close()
          }else {
              this.$notify.error({message: 'Gescheitert Medikament absetzen !!', position: 'top right', closeButton: false, timeOut: 5000})
          }
        })
        .catch((error) => {
          this.$notify.error({message: error.response.data.ResponseStatus.Message, position: 'top right', closeButton: false, timeOut: 5000})
        })
        .finally(() => {
          this.loading = false
          this.deleteMedicineID = null
          this.close()
          this.loadMedicine()
        })
    },

    closeSettingModal () {
      this.modalSetting = false
      this.isInterval = false
      this.isTrue = false
    },

    saveFilter () {
      this.modalSetting = false
      this.loadMedicine()
    },

    saveModal () {
      this.modal = false
      this.loadMedicine()
    },

    saveCourseModal () {
      this.modalCourse = false
      this.loadMedicine()
    },

    loadMedicine() {
      this.loading = true
      this.$http.get(`/Medikamentenblatt/${this.roomID}/${this.isTrue}`)
        .then(res => {
          if(res.data.data) {
            var tableData = res.data.data
            // set Verlauf data into table
              let listsInterval = []
              let listTable = []
              let medikamentArray = []
              let intervalArray = []
              let tableArray = []
              const filters = this.$options.filters
              let art_medicine_option = this.artMedicineCourseOption

              tableData.map(function(value) {
                // set date format and key with text to element
                if(value.Verlauf.length > 0) {
                  value.Verlauf.map(function(val) {
                    val.Datum = filters.dateFormat(val.Datum)
                    val.MedikamentText = value.MedikamentText
                    val.ArtText = art_medicine_option[val.Art-1] ? art_medicine_option[val.Art-1].text : ""
                  })
                  value.Intervall ? Array.prototype.push.apply(listsInterval, value.Verlauf)
                    : Array.prototype.push.apply(listTable, value.Verlauf)
                }

                // store filter data
                if(value.Intervall) {
                  intervalArray.push(value)
                }else {
                  tableArray.push(value)
                }
                medikamentArray.push({ 'text': value.MedikamentText, 'value': value.Id })
              })

              this.medikamentOption = medikamentArray
              this.verlaufData.rows = this.isInterval ? listsInterval : listTable
              this.tableData = this.isInterval ? intervalArray : tableArray
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    openModal () {
      this.getArtOptions()
      this.modal = !this.modal
    },

    closeModal () {
      this.modal = false
      this.tempArtOptions = []
    },

    getArtOptions() {
      this.$http.get('/Referenzdaten/mat')
          .then(res => {
              if(res.data) {
                  let artArray = res.data.data
                  let list=[]
                  artArray.map(function(art) {
                      const element = { 'text': art.Text, 'value': art.Id }
                      list.push(element)
                  })
                  this.artOptions = list
                  this.tempArtOptions = this.artOptions
              }
          })
    },
  }
}
</script>
